import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { fetchDeviceCount ,fetchUserCount,fetchAndFilterUsers } from '@utils/utils';
import { HOSPITAL, INDIVIDUAL, NURSE, ADMIN ,CONFIRMED} from '@constants/constants';
import Swal from 'sweetalert2';
const MySwal = Swal;

  
const SuperAdminTotalData = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [deviceCount, setDeviceCount] = useState<number | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [individualUserCount, setIndividualUserCount] = useState<number | null>(null);
    const [hospitalUserCount, setHospitalUserCount] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        fetchAndFilterUsers()
        .then(({ totalCount, individualCount, hospitalCount }) => {
            setIndividualUserCount(individualCount);
            setHospitalUserCount(hospitalCount);
        })
        .catch(error => {
            console.error("Error fetching and filtering users:", error);
        });
        const fetchData = async () => {
            const result = await fetchDeviceCount();
      
            if (result.error) {
              setError(result.error);
            } else {
              // Ensure result.count is defined before setting state
              if (result.count !== undefined) {
                setDeviceCount(result.count);
              } else {
                setDeviceCount(0); // Set to null if count is undefined (optional)
              }
            }
          };
          fetchData();
        fetchAndFilterUsers();
    }, []); 

      
    return (
        <div className="flex gap-5 mt-2 mx-auto">
            <div className="cart  items-center bg-total_device rounded-2xl py-2  flex w-[234px]">
                {/* <div className="flex justify-between items-center"> */}
                <div className="flex justify-content-between space-y-5 flex-col">
                    <span className="px-3 pb-3">
                        <label className="font-semibold text-cart_box">
                        {t('dashboard.total_device')}
                        </label>
                    </span>
                    {/* <h4 className="font-bold text-lg text-total_device_text px-3 pt-6 pb-1"> */}
                    <h4 className="font-bold text-3xl text-total_device_text px-3 pb-1">
                      {deviceCount !== null ? deviceCount : 0}
                    </h4>
                </div>
                {/* </div> */}
            </div>
            <div className="cart bg-total_individual items-center rounded-2xl py-2  flex w-[234px]">
                {/* <div className="flex justify-between items-center"> */}
                <div className="flex justify-content-between space-y-5 flex-col">
                    <span className="px-3 pb-3">
                        <label className="font-semibold text-cart_box">
                        {t('dashboard.total_individual')}
                        </label>
                    </span>
                    <h4 className="font-bold text-3xl text-total_individual_text px-3 pb-1">
                        {individualUserCount !== null ? individualUserCount : 0}
                    </h4>
                </div>
                {/* </div> */}
            </div>
            <div className="cart bg-total_hospital  items-center rounded-2xl py-2 flex w-[234px]">
                {/* <div className="flex justify-between items-center"> */}
                <div className="flex  justify-content-between space-y-5 flex-col">
                    <span className="px-3 pb-3">
                        <label className="font-semibold text-cart_box">
                        {t('dashboard.total_hospital')}
                        </label>
                    </span>
                    <h4 className="font-bold text-3xl text-total_hospital_text px-3 pb-1">
                        {hospitalUserCount !== null ? hospitalUserCount : 0}
                    </h4>
                </div>
                {/* </div> */}
            </div>
        </div>
    );
};
export default SuperAdminTotalData;
